import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import CustomEditor from "../../../component/CustomEditor";

const AddPolicy = () => {
  let userInfo = JSON.parse(localStorage.getItem('admin-info'));
  const { id } = useParams();
  const navigate = useNavigate();
  const editorRef = useRef();
  
  const [title, setTitle] = useState("");
  const [newdata, setNewdata] = useState({
    title: '',
    policyDetails: ''
  });

  const fetchData = async (url, setData) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(`https://igapi.heuristticminds.com/api/PolicyList/Get-GetPolicyDetailsToEditByID?id=${id}`, (data) => {
        const policyData = data[0];
        setNewdata({
          title: policyData.title,
          policyDetails: policyData.policyDetails,
        });
        setTitle(policyData.title);
      });
    }
  }, [id]);

  const handleTitleChange = (event) => {
    const newTitle = event.target.value;
    setTitle(newTitle);
    setNewdata(prevData => ({
      ...prevData,
      title: newTitle
    }));
  };

  const handlePolicyDetailsChange = (content) => {
    setNewdata(prevData => ({
      ...prevData,
      policyDetails: content
    }));
  };

  const handleUpdate = async () => {
          debugger;
          // Check if both title and policyDetails are not empty
          if (title.trim() === '' || newdata.policyDetails.trim() === '') {
            alert('Please fill in all fields.');
            return;
        }
              
          const formData = {
              id: parseInt(id, 10),
              title: newdata.title,
              policyDetails: newdata.policyDetails,
              createdBy: userInfo.id
          };
  
          try {
              // Make the API call to save the form data
              const response = await fetch('https://igapi.heuristticminds.com/api/PolicyList/Update-UpdatePolicyDetails', {
                  method: 'PUT',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formData),
              });
              if (response.ok) {
  
                  setTitle(''); // Clear the title input Box
                  // Clear CKEditor content using the API
                  if (editorRef.current) {
                      editorRef.current.setData(''); // This clears the editor content
                  }
                  alert("Policy Details Updated Successfully !!!");
                  
                  navigate(`/policy/`);
  
              } else {
                  // Handle error cases
                  console.error('Error saving form data:', response.statusText);
              }
          } catch (error) {
  
              console.error('Error saving form data:', error);
          }
  
      };


      const handleSubmit = async () => {
          
              // Check if both title and policyDetails are not empty
          if (title.trim() === '' || newdata.policyDetails.trim() === '') {
            alert('Please fill in all fields.');
            return;
        }                 
      
        const formData = {
          title: newdata.title,
          policyDetails: newdata.policyDetails,
          createdBy: userInfo.id
        };
              try {
                  
                  // Make the API call to save the form data
                  const response = await fetch('https://igapi.heuristticminds.com/api/PolicyList/Add-SavePolicyDetails', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(formData),
                  });
                  if (response.ok) {

                    alert(`Policy Details Saved Successfully!`);

            setTitle('');
            setNewdata({ title: '', policyDetails: '' });

            if (editorRef.current) {
                editorRef.current.setData('');
            }
            navigate(`/policy/`); 
                      
                      
                  } else {
                      // Handle error cases
                      console.error('Error saving form data:', response.statusText);
                  }
              } catch (error) {
                  console.error('Error saving form data:', error);
              }
      
          };

  


  return (
    <>
      <Header />
      <div id="layoutSidenav">
        <SideNav />
        <div id="layoutSidenav_content">
          <PageHeader name={id ? "Edit Policy Details" : "Add Policy Details"} icon='bi bi-activity' />
          <div className="container-xl px-4">
            <div className="row">
              <div className="col-lg-12 mb-4">
                <div className="card mb-4 vh-100">
                  <div className="card-header">Policy Details</div>
                  <div className="card-body">
                    <NavLink className="btn btn-primary float-end" to={'/policy'}>
                      <i className="bi bi-arrow-return-left"></i> Back
                    </NavLink>
                    <div className="clearfix"></div>
                    <div className="p-4 pt-2">
                      <div className="row">
                        <div className="col-sm-6 form-group mb-3">
                          <label>Title <span style={{ color: "#ff0000" }}>*</span></label>
                          <input
                            type="text"
                            name="title"
                            value={title}
                            className="form-control"
                            maxLength={45}
                            placeholder="Title"
                            onChange={handleTitleChange}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 form-group mb-3">
                          <label>Policy Details <span style={{ color: "#ff0000" }}>*</span></label>
                          <CustomEditor 
                            ref={editorRef} 
                            value={newdata.policyDetails} 
                            onChange={handlePolicyDetailsChange} 
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6 form-group mt-3">
                          {id>0 ?
                            <button type="button" onClick={handleUpdate} className="btn btn-primary w-50">Update</button>
                            :
                            <button type="submit" onClick={handleSubmit} className="btn btn-primary w-50">Submit</button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AddPolicy;
